import React, { FC } from 'react';
import { formatDate } from 'utils/format';
import { useTranslation } from 'react-i18next';
import { DeviationAction } from 'models/deviations';
import CardInformation from 'components/shared/card-information/card-information.component';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

type DeviationActionListItemProps = {
    deviationAction: DeviationAction;
    onOpenUpdateModal: (deviationAction: DeviationAction) => void;
    onOpenConfirmDialog: (deviationId: string) => void;
    versionCheck: boolean;
};

const DeviationActionListItem: FC<DeviationActionListItemProps> = ({
    deviationAction,
    onOpenUpdateModal,
    onOpenConfirmDialog,
    versionCheck,
}: DeviationActionListItemProps) => {
    const { t: translate } = useTranslation(['deviations']);

    const deviationActionTitle = (deviationAction: DeviationAction) => {
        // DD-3494 rename: new field first, deprecated field as fallback until backfill.
        return deviationAction.visibleForCustomer ?? deviationAction.visibleForDentist
            ? `${translate('deviations:ACTION')} (${translate('deviations:VISIBLE_FOR_CUSTOMER')})`
            : `${translate('deviations:ACTION')}`;
    };

    const actionSubHeader = (deviationAction: DeviationAction) => {
        return `${formatDate(deviationAction.addedOn, 'datetime')} ${translate('deviations:BY')} ${
            deviationAction.technician
        }`;
    };

    return (
        <CardInformation
            icon={<CheckCircleIcon color="success" />}
            title={deviationActionTitle(deviationAction)}
            subHeader={actionSubHeader(deviationAction)}
            content={deviationAction.report}
            deviationAction={deviationAction}
            onOpenUpdateModal={onOpenUpdateModal}
            onOpenConfirmDialog={onOpenConfirmDialog}
            versionCheck={versionCheck}
            dataTest="deviation-action-list-item"
        />
    );
};

export default DeviationActionListItem;
